<div
     [matMenuTriggerFor]="menuTriggerFor"
     [matTooltip]="tooltip"
     [ngClass]="customClass"
     [ngStyle]="{'width.px': size, 'height.px': size}">
  {{ initials }}
</div>
